import { memo } from 'react';

import { useConversationListSectionLogic } from './conversation-list-section.hook';
import type { TConversationListSectionConfig } from './conversation-list-section.types';

import { Tabs } from './components/tabs';
import { ConversationsFilter } from './components/conversations-filter';
import { ConversationList } from './components/conversation-list';

import * as S from './conversation-list-section.styles';

const ConversationListSection = memo((props: TConversationListSectionConfig) => {
	const {
		show,
		tabItems,
		isShowConversationsFilter,
		handleFilterChange
	} = useConversationListSectionLogic(props);

	return (
		<S.Wrapper show={show} data-qa="conversation-list-section">
			<S.Header data-qa="conversation-list-header">
				<Tabs itemList={tabItems} reducerName="conversation" />
			</S.Header>
			{isShowConversationsFilter && (
				<ConversationsFilter onFilterChange={handleFilterChange} />
			)}
			<S.ListContent>
				<ConversationList />
			</S.ListContent>
		</S.Wrapper>
	);
});

ConversationListSection.displayName = 'ConversationListSection';
export { ConversationListSection };
